import React from "react";

import ContactMeHero from "./Hero/contactHero";
import ContactMeForm from "./ContactForm/contactForm";

const ContactMe = () => {
  return (
    <div>
      <ContactMeHero />
      <ContactMeForm />
    </div>
  );
};

export default ContactMe;
